module.exports = __webpack_public_path__ + "img/cinco-passos.ac624f79.jpg";